/*
    Copyright © 2025 TRIPLES INNOVATION. All rights reserved.
    Proprietary and confidential. This source code is the exclusive property of
    TRIPLES INNOVATION and protected by copyright and trade secret law.
    Any unauthorized use, copying, modification, distribution, or disclosure
    is strictly prohibited without prior written permission from TRIPLES INNOVATION.
    Use is subject to a written license agreement with TRIPLES INNOVATION.
*/

export enum DialogMode {
    VIEW = 'view',
    EDIT = 'edit',
    CREATE = 'create',
}

export interface DialogFormConfig<T> {
    /**
     * Array of field keys that are required for form submission
     */
    requiredFields: ReadonlyArray<keyof T>;
    
    /**
     * Initial/default values for all form fields
     */
    defaultValues: T;
    
    /**
     * Optional additional validation conditions beyond required fields
     * Returns true if valid, false otherwise
     */
    additionalValidation?: (fields: T) => boolean;
}

export interface DialogStateInfo<T = unknown> {
    isOpen: boolean;
    mode?: DialogMode;
    initialValues?: Partial<T>;
    entityId?: number | string;
}
